import { atom } from "recoil";
import { getSiteOptions } from "../services/api";
import { SiteOptionsType } from "../types/SiteOptionsType";

export const SiteOptionsState = atom<SiteOptionsType>({
	key: "SideOptionsState",
	default: getSiteOptions(),
});
